import ConnectedNavigationBar, { NavigationBar } from './NavigationBar';

export { NavigationBar };
export default ConnectedNavigationBar;
